var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("verify-tree-grid", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "list",
            expression: "view==='list'"
          }
        ],
        ref: "verifyTreeGrid",
        attrs: {
          context: _vm.context,
          "is-query": _vm.isQuery,
          "integrated-logistics-type": _vm.logisticsType
        },
        on: {
          look: _vm.lookHandle,
          add: _vm.addHandle,
          edit: _vm.editHandle,
          split: _vm.splitHandle,
          copy: _vm.copyHandle,
          refresh: _vm.refreshHandle
        }
      }),
      _c("verify-workspace", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "detail",
            expression: "view==='detail'"
          }
        ],
        ref: "verifyWorkspace",
        attrs: {
          "parent-context": _vm.context,
          view: _vm.view,
          "integrated-logistics-type": _vm.logisticsType
        },
        on: {
          copy: _vm.copyHandle,
          back: _vm.backToList,
          add: _vm.addHandle,
          refresh: _vm.refreshHandle
        }
      }),
      _c("job-copy-window", {
        attrs: {
          visible: _vm.copyDialog.visible,
          lob: _vm.copyDialog.job.lob || "",
          "container-load-type": _vm.copyDialog.job.containerLoadType || ""
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.copyDialog, "visible", $event)
          },
          confirmCallBack: _vm.confirmCallBackHandler
        }
      }),
      _vm.orderTypeDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "app-main-inner",
              attrs: {
                visible: _vm.orderTypeDialog.visible,
                title: _vm.$t("CargoMsg.Cargo_OrderType"),
                width: _vm.$selectByLang("400px", "640px"),
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.orderTypeDialog, "visible", $event)
                },
                close: function($event) {
                  _vm.orderTypeDialog.visible = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: {
                    "flex-direction": "column",
                    "padding-bottom": "10px"
                  }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.orderTypeDialog.containerLoadType,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.orderTypeDialog,
                            "containerLoadType",
                            $$v
                          )
                        },
                        expression: "orderTypeDialog.containerLoadType"
                      }
                    },
                    [
                      !_vm.orderTypeDialog.masterFlag
                        ? _c(
                            "el-radio",
                            { attrs: { no: "orderType0", label: "TT" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_TruckTrailer"))
                              )
                            ]
                          )
                        : _vm._e(),
                      !_vm.orderTypeDialog.masterFlag
                        ? _c(
                            "el-radio",
                            {
                              staticStyle: { "margin-left": "-20px" },
                              attrs: { no: "orderType1", label: "CL" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "CargoMsg.Cargo_WholeVehicleAndLessThanCarload"
                                  )
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      !_vm.orderTypeDialog.masterFlag
                        ? _c(
                            "el-radio",
                            {
                              staticStyle: { "margin-left": "-20px" },
                              attrs: { no: "orderType2", label: "IC" }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_IC")))]
                          )
                        : _vm._e(),
                      _vm.orderTypeDialog.masterFlag
                        ? _c(
                            "el-radio",
                            {
                              staticStyle: { "margin-left": "80px" },
                              attrs: { no: "orderType3", label: "IC" }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_IC_Master")))]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "Confirm", type: "primary" },
                      on: { click: _vm.confirmJobLovHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "Cancel" },
                      on: {
                        click: function() {
                          this$1.orderTypeDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }